export interface NewsItem {
  id: string;
  title: string;
  category: string;
  summary: string;
  cover: string;
  author: string;
  publishedAt: string;
  tags: string[];
  content: string[];
}

export const newsCategories = ["电影新闻", "电视剧动态", "行业观察"];

export const newsList: NewsItem[] = [
  {
    id: "news-1",
    title: "暑期档票房再创新高，国产科幻片成最大赢家",
    category: "行业观察",
    summary:
      "刚刚结束的暑期档交出了一份亮眼成绩单，多部国产影片口碑票房双丰收，其中科幻题材表现尤为突出。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20modern%20cinema%20hall%20with%20warm%20amber%20seats%20and%20soft%20lighting%2C%20cinematic%20color%20grading%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=md-news-1&orientation=landscape",
    author: "麻豆精品编辑部",
    publishedAt: "2025-09-02",
    tags: ["暑期档", "票房", "科幻"],
    content: [
      "随着最后一部重点影片下线，今年的暑期档正式收官。据多方统计，今年暑期档总票房较去年同期实现稳步增长，观影人次也创下近年新高。",
      "从类型分布来看，科幻、悬疑与动画三大题材成为拉动大盘的主要力量。多部国产科幻影片凭借扎实的剧本与不断精进的特效水准，赢得了观众与影评人的双重认可。",
      "有业内人士指出，观众对内容品质的要求正在持续提高，单纯依靠明星阵容或营销噱头的影片越来越难以获得理想成绩。这一变化，也将倒逼创作端更加重视故事本身。",
      "接下来，多部备受期待的影片已经定档秋季与贺岁档，影视市场有望延续良好势头。",
    ],
  },
  {
    id: "news-2",
    title: "科幻巨制《星际迷航：黎明边境》发布终极预告，视效震撼引热议",
    category: "电影新闻",
    summary:
      "备受关注的科幻新作发布终极预告片，短短两分半钟的片段展示了惊人的世界观构建与特效水准，迅速登上热搜。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20film%20festival%20red%20carpet%20with%20spotlights%20at%20night%2C%20cinematic%20color%20grading%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=md-news-2&orientation=landscape",
    author: "影讯组",
    publishedAt: "2025-08-20",
    tags: ["星际迷航", "预告片", "视效"],
    content: [
      "《星际迷航：黎明边境》今日发布终极预告。预告片以一段低沉的旁白开场，随后快速切换到气势恢宏的行星景观与精密的空间站内部。",
      "制作团队表示，影片中大量场景采用了实景搭建与虚拟拍摄相结合的方式，力求在视觉真实感与艺术想象之间取得平衡。",
      "预告片发布后迅速引发讨论，不少观众表示「光看预告就值回票价」。影片将于近期正式登陆院线，并同步开启多版本的格式放映。",
    ],
  },
  {
    id: "news-3",
    title: "《迷雾档案馆》口碑持续走高，悬疑剧迎来新范本",
    category: "电视剧动态",
    summary:
      "这部以档案馆为背景的悬疑剧集凭借缜密的叙事结构与出色的群像塑造，成为近期讨论度最高的作品之一。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20film%20production%20set%20with%20cameras%20and%20lighting%20rigs%2C%20cinematic%20color%20grading%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=md-news-3&orientation=landscape",
    author: "剧集观察",
    publishedAt: "2025-05-28",
    tags: ["迷雾档案馆", "悬疑", "口碑"],
    content: [
      "《迷雾档案馆》自开播以来评分稳步上升，成为本季度最受关注的黑马剧集。剧集以一座存放悬案的档案馆为核心场景，用单元剧与主线交织的方式推进叙事。",
      "与许多同类作品不同，该剧并未过度依赖反转，而是把重心放在案件背后的人性与时代语境上，让每一个故事都拥有独立的重量。",
      "不少观众认为，这部剧为国产悬疑剧提供了一种新的可能：不必追求强刺激，克制的表达同样能够抓住人心。",
    ],
  },
  {
    id: "news-4",
    title: "家庭观影场景持续升温，优质内容成为留住用户的关键",
    category: "行业观察",
    summary:
      "随着家庭大屏设备普及，越来越多人选择在家中与家人一起观影。内容平台之间的竞争，正回归到作品质量本身。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20cozy%20home%20streaming%20setup%20with%20a%20glowing%20screen%20at%20dusk%2C%20cinematic%20color%20grading%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=md-news-4&orientation=landscape",
    author: "麻豆精品编辑部",
    publishedAt: "2025-04-11",
    tags: ["家庭观影", "流媒体", "趋势"],
    content: [
      "近一年来，家庭观影场景的比例明显提升。大屏设备与稳定的网络环境，让「在家看一部好电影」变得前所未有的方便。",
      "与之相伴的，是用户对内容质量要求的提高。调查显示，观众在选择影片时，剧情简介、评分与真实口碑的影响力正在超过单纯的推荐位曝光。",
      "对于内容平台而言，这意味着真正的竞争力来自能否持续提供优质、多元且易于被发现的作品。",
    ],
  },
  {
    id: "news-5",
    title: "年度影视颁奖季前瞻：哪些作品最有希望脱颖而出？",
    category: "电影新闻",
    summary:
      "随着各大奖项陆续公布提名，今年影视颁奖季的格局逐渐清晰。我们整理了最值得关注的几部作品与看点。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20golden%20award%20statuette%20on%20a%20dark%20stage%20with%20bokeh%20lights%2C%20cinematic%20color%20grading%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=md-news-5&orientation=landscape",
    author: "影评组",
    publishedAt: "2025-10-01",
    tags: ["颁奖季", "口碑", "预测"],
    content: [
      "进入十月，各大影视奖项的提名名单陆续揭晓，一年一度的颁奖季正式拉开帷幕。",
      "从目前释放的信号来看，剧情片与技术类影片之间的竞争尤为激烈。前者胜在情感深度与表演，后者则在视听呈现上不断突破边界。",
      "无论最终结果如何，颁奖季的意义或许并不只在于奖项归属，更在于它让那些被忽视的好作品重新回到大众视野。",
    ],
  },
  {
    id: "news-6",
    title: "多地影视基地迎来拍摄高峰，行业信心逐步恢复",
    category: "电视剧动态",
    summary:
      "随着新项目密集开机，多个影视基地的摄影棚排期趋于紧张，行业上下游的活跃度明显回升。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20director%20chair%20on%20an%20outdoor%20film%20set%20at%20sunset%2C%20cinematic%20color%20grading%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=md-news-6&orientation=landscape",
    author: "产业观察",
    publishedAt: "2025-06-15",
    tags: ["影视基地", "开机", "行业"],
    content: [
      "进入年中，多个影视基地的拍摄档期开始紧张。据工作人员介绍，近期开机的项目数量较去年同期有明显增加，其中剧集项目占比最高。",
      "行业回暖也带动了相关配套环节的活跃，道具、置景、后期等团队纷纷进入满负荷运转状态。",
      "有从业者表示，经历了几年的调整期之后，行业正在回归理性与专注，把更多精力放回到作品打磨上。",
    ],
  },
];